export const emojis = [
	{ pattern: />:\(/g, value: "😠" },
	{ pattern: /:\)/g, value: "🙂" },
	{ pattern: /:-\)/g, value: "🙂" },
	{ pattern: /:\(/g, value: "🙁" },
	{ pattern: /:-\(/g, value: "🙁" },
	{ pattern: /:'\(/g, value: "😢" },
	{ pattern: /:D/g, value: "😃" },
	{ pattern: /=D/g, value: "😃" },
	{ pattern: /:O/g, value: "😮" },
	{ pattern: /:-O/g, value: "😮" },
	{ pattern: /;\)/g, value: "😉" },
	{ pattern: /ToT/g, value: "😭" },
	{ pattern: /T_T/g, value: "😭" },
	{ pattern: /<3/g, value: "❤️" },
	{ pattern: /:\\/g, value: "😕" },
	{ pattern: /:\*/g, value: "😘" },
	{ pattern: /-_-/g, value: "😑" },
];
